import i18n from '@/locales'

export const serverTypeMap = {
  server: i18n.t('common.server'),
}
